export enum DecisionEnum {
  GREEN = 'G',
  ORANGE = 'O',
  RED = 'R'
}
